export default "__VITE_ASSET__f55b0c45__"